
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.25","d":"M1.156.625h35.515v28.75H1.156z"}}),_c('path',{attrs:{"fill":"#EA983F","d":"M4.857 5h12.976v13.75H4.857zM19.994 5H32.97v13.75H19.994z"}}),_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.875","d":"M4.857 21.563h28.115M4.857 24.063h28.115"}})])
          )
        }
      }
    